var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsArchiveOutlineBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.29,45a2.54,2.54,0,0,1,2.53-2.54H65.18a2.54,2.54,0,0,1,0,5.08H34.82A2.53,2.53,0,0,1,32.29,45ZM80.9,79.12V33.07H19.1V79.12C19.1,82.91,23.22,86,27,86H74A6.91,6.91,0,0,0,80.9,79.12ZM76.18,37.77V79.12A2.19,2.19,0,0,1,74,81.3H27c-1.21,0-3.21-1-3.21-2.18V37.77ZM86,20.88A6.91,6.91,0,0,0,79.09,14H20.91A6.91,6.91,0,0,0,14,20.88V30.1H86Zm-67.28,0a2.19,2.19,0,0,1,2.19-2.18H79.09a2.19,2.19,0,0,1,2.19,2.18v4.51H18.72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsArchiveOutlineBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_Archive_Outline_Black_RGB.ebbd07dc2c9ba9cc6a14e5a4257c1a9d.svg";
export { ForwardRef as ReactComponent };